module.exports = __webpack_public_path__ + "static/media/ill_ovriga_besvar.366bcd7a.svg";